import React from "react";
import "./Topbar.css";

const Topbar = () => {
  const role = localStorage.getItem("role") || "fpo_admin";
  const email = localStorage.getItem("email") || "";

  const selectedFpoName =
    localStorage.getItem("selected_fpo_name") ||
    localStorage.getItem("fpo_name") ||
    "";

  const roleLabel =
    role === "super_admin" ? "Super Admin" : "FPO Admin";

  return (
    <div className="topbar">
      <div>
        <div className="topbar-title">FPO Vyapar</div>
        <div className="topbar-subtitle">
          {roleLabel}
          {selectedFpoName ? ` · ${selectedFpoName}` : ""}
        </div>
      </div>

      <div className="topbar-user">
        {email ? email : roleLabel}
      </div>
    </div>
  );
};

export default Topbar;